
import Login from "./index";
export default class LoginView extends Login {}
